import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { barbersLimitedRegistrationApiUrl } from '../../config';

export const barberDeleteServices = async (
  serviceId: bigint,
  barberId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/barbers/${barberId}/service`,
    params: { serviceId },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.request(config);
};

export const shopBarberDeleteServices = async (
  serviceId: bigint,
  shopId: bigint,
  barberId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/shops/${shopId}/barber/${barberId}/services`,
    params: { serviceId },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.request(config);
};

export const shopOwnerDeleteServices = async (
  id: bigint,
  shopOwnerId: bigint | null,
  shopId: bigint,
  barberId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/shopOwners/${shopOwnerId}/shops/${shopId}/barber/${barberId}/services/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.request(config);
};

export const shopDeleteBarber = async (
  shopId: bigint,
  barberId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/shops/${shopId}/barbers/${barberId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  return axios.request(config);
};

export const shopDeleteImage = async (
  imageName: string,
  imageId: bigint,
  shopId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/shops/${shopId}/images`,
    data: {
      imageName,
      imageId,
    },
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.request(config);
};

export const barberDeleteImage = async (
  imageName: string,
  imageId: bigint,
  barberId: bigint,
  token: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${barbersLimitedRegistrationApiUrl}/barbers/${barberId}/images`,
    data: {
      imageName,
      imageId,
    },
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.request(config);
};
